if(!customElements.get('showcase-component')) {
  customElements.define(
    'showcase-component',
    class ShowcaseComponent extends HTMLElement {
      #sliderEl;
      #sliderInstance;
      
      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.#sliderEl) return;

        const slides = this.querySelectorAll('.showcase-slide');
        if(!slides?.length > 0) return;

        const paginationContent = new Map(Array.from(slides).map((slide, index) => {
          const icon = slide.dataset.thumbIcon;
          const text = slide.dataset.thumbText;
          return [index, { icon, text }];
        }));

        const options = {
          speed: 2000,
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: this.parentNode.querySelector('.slider-controls .slider-pagination'),
            renderBullet: function(index, className) {
              const content = paginationContent.get(index);
              return `
                <div class="pagination-item ${className}">
                  <img 
                    src="${content.icon}" 
                    alt="${content.text}"
                  />
                  <span>${content.text}</span>
                </div>
              `;
            },
            clickable: true
          }
        };

        this.#sliderInstance = new Swiper(this.#sliderEl, options);
      }
    }
  );
}